import { THANK_YOU_ACTION, COMMON_CONTENT_ACTION, THANK_YOU_ACTION_LOADER } from "../type"
 
const initialState ={
    loader : false,
    data :{},
    common_data :{}
}
 
const thankyouReducer  = (state = initialState, action) => {
    switch (action.type){
        case THANK_YOU_ACTION_LOADER:{
            return {...state,loader : action.loader};
        }
        case THANK_YOU_ACTION :{
            return {...state, data: action.data};
        }
        case COMMON_CONTENT_ACTION :{
             return {...state, common_data: action.data};
        }
        default :{
            return state
        }
    }
}
 
export default thankyouReducer;